import { CustomerRule } from '../../../../dto/admin-rule-models';
import { useState } from 'react';
import { App, Button, Card, Typography } from 'antd';
import { CustomerRuleForm } from './customer-rule-form';
import { CopyOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

const { Title } = Typography;

type CustomerRuleCardProps = {
  rule: CustomerRule;
  onSubmit: (rule: CustomerRule) => void;
  onDuplicate: (duplicatedRule: CustomerRule) => void;
  shouldDisplayAddButton: (status: boolean) => void;
};

export const CustomerRuleCard = ({ rule, onSubmit, onDuplicate, shouldDisplayAddButton }: CustomerRuleCardProps) => {
  const { modal } = App.useApp();
  const [shouldEdit, setShouldEdit] = useState(false);
  const onSubmitEdit = (rule: CustomerRule) => {
    onSubmit(rule);
    setShouldEdit(false);
  };

  const setEditDisplay = (status: boolean) => {
    shouldDisplayAddButton(!status);
    setShouldEdit(status);
  };

  const handleDuplicate = () => {
    const duplicated = { ...rule };
    duplicated.id = 0;
    duplicated.feId = crypto.randomUUID();
    duplicated.title = `${duplicated.title} COPY`;
    onDuplicate(duplicated);
  };

  const deleteRule = () => {
    const updatedRule = { ...rule, isDeleted: true };
    onSubmit(updatedRule);
  };

  const showDeleteConfirm = () => {
    modal.confirm({
      title: 'Are you sure you want to delete this rule?',
      icon: <DeleteOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteRule();
      },
    });
  };

  return (
    <Card style={{ marginBottom: '25px' }}>
      {shouldEdit ? (
        <CustomerRuleForm rule={rule} onSubmit={onSubmitEdit} onCancel={() => setEditDisplay(false)} />
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Title level={3} style={{ margin: 0 }}>
              {rule.title}
            </Title>
            <div
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: 16,
              }}
            >
              <Button onClick={() => setEditDisplay(true)} icon={<EditOutlined />} style={{ marginRight: '10px' }}>
                Edit
              </Button>
              <Button onClick={handleDuplicate} icon={<CopyOutlined />} style={{ marginRight: '10px' }}>
                Duplicate
              </Button>
              <Button onClick={showDeleteConfirm} icon={<DeleteOutlined />}>
                Delete
              </Button>
            </div>
          </div>
          <p>{rule.description}</p>
        </>
      )}
    </Card>
  );
};
